import { toPath } from "lodash";
import { ColumnEdited } from "../types";

const getColumnPointingName = (
  name: string,
  columnEdited: ColumnEdited | null
): string => {
  const pathName = toPath(name);

  const restPath =
    pathName.slice(1).length > 0 ? pathName.slice(1).join(".") : "";

  const newPointingName = columnEdited
    ? pathName[0] === "element"
      ? `element.listFields.fields.${columnEdited.index}${
          restPath && `.${restPath}`
        }`
      : pathName[0] === "fieldDef"
      ? `fieldDef.schema.${columnEdited.name}${restPath && `.${restPath}`}`
      : name
    : name;

  return newPointingName;
};

export default getColumnPointingName;
